const CardTag = ({
  text = "Plano",
  backgroundColor = "#5451fb",
  textColor = "#FFFFFF",
  fontWeight = "400",
}) => {
  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
        padding: "4px 8px",
        fontSize: "12px",
        borderRadius: "5px",
        width: "fit-content",
        fontWeight: fontWeight,
      }}
    >
      {text}
    </div>
  );
};

export default CardTag;
